import { Slider, withStyles } from '@material-ui/core'
import { KelmanCarousel } from '@phaco3d/kelman'
import { Maybe } from 'graphql/jsutils/Maybe'
import React, { useEffect, useState } from 'react'
import { CataractSimulation } from '../../types/graphql'

interface SimulationProps {
  simulations: Maybe<CataractSimulation>[]
}
const CustomSlider = withStyles({
  root: {
    '&.MuiSlider-root': {
      padding: '13px 0'
    }
  }
})(Slider)

type Images = string[]
type Marks = { value: number; label?: React.ReactNode }[]

const SimulationCarousel: React.FC<SimulationProps> = ({ simulations }) => {
  const [images, setImages] = useState<Images>([])
  const [marks, setMarks] = useState<Marks>([])
  const [index, setIndex] = React.useState(0) // create state to keep track of images index, set the default index to 0

  const handleChange = (value: number | number[]) => {
    if (marks.findIndex(m => m.value === value) !== index) {
      setIndex(marks.findIndex(m => m.value === value))
    }
  }

  useEffect(() => {
    simulations.forEach(i => i && setImages(oldState => [...oldState, i.thumb]))
    simulations.forEach(
      i =>
        i &&
        setMarks(oldState => [
          ...oldState,
          { label: `${i.progress}`, value: i.progress }
        ])
    )
  }, [])

  return (
    <>
      <KelmanCarousel images={images} index={index} />
      <div
        style={{
          position: 'absolute',
          bottom: 10,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <div style={{ width: 500 }}>
          <CustomSlider
            aria-labelledby="discrete-slider"
            valueLabelDisplay="auto"
            marks={marks}
            step={null}
            min={marks[0] && marks[0].value}
            onChange={(_, value) => {
              handleChange(value)
            }}
          />
        </div>
      </div>
    </>
  )
}

export default SimulationCarousel
